import { definePlayerFeature } from "../../feature.js";
import { listen } from "@videojs/utils/dom";
import { isMediaPlaybackRateCapable } from "@videojs/media";
//#region src/dom/store/features/playback-rate.ts
const DEFAULT_RATES = [
	.2,
	.5,
	.7,
	1,
	1.2,
	1.5,
	1.7,
	2
];
const playbackRateFeature = definePlayerFeature({
	name: "playbackRate",
	state: ({ target }) => ({
		playbackRates: DEFAULT_RATES,
		playbackRate: 1,
		setPlaybackRate(rate) {
			const { media } = target();
			if (isMediaPlaybackRateCapable(media)) media.playbackRate = rate;
		}
	}),
	attach({ target, signal, set }) {
		const { media } = target;
		if (!isMediaPlaybackRateCapable(media)) return;
		const sync = () => set({ playbackRate: media.playbackRate });
		sync();
		listen(media, "ratechange", sync, { signal });
	}
});
//#endregion
export { playbackRateFeature };

//# sourceMappingURL=playback-rate.js.map